export const MODAL_TYPE = {
  PLANCANCELED: 'plan',
  DOMAINCANCELED: 'domain',
  ECOMMERCEPLUS: 'ecommercePlus',
  NEWSITE: 'newSite',
  SPECIALIST: 'specialist',
};
